__turbopack_context__.v({
  "className": "libre_baskerville_bb439b94-module__HeQ5yG__className",
  "variable": "libre_baskerville_bb439b94-module__HeQ5yG__variable",
});
